import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import {Translate} from "@components/Theme/Translate/Translate"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import formatDate from "@helpers/formatDate"
import {BlogPostModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import React from "react"

import styles from "./BlogCardHorizontal.module.scss"

type Props = {
	data: BlogPostModuleType
	className?: string
}

const BlogCardHorizontal = (props: Props): JSX.Element => {
	return (
		<Link
			className={`${styles.cardContainer} ${props.className}`}
			href={props.data.link}
			rel={"noreferrer"}
		>
			<NewResponsiveImage
				{...props.data.thumbui}
				containerClassName={styles.imageContainer}
				imageClassName={styles.image}
				alt={props.data.title}
			/>

			<div className={styles.contentContainer}>
				<Typography
					className={styles.readMore}
					content={props.data.title}
					fontWeight={600}
					size={Size.XXS}
					truncate={75}
					variant={Variant.Description}
				/>
				<Separator size={32} />
				<div className={styles.buttonContainer}>
					<Typography
						content={
							<>
								<Translate capitalizeFirst>Posted on</Translate>
								: {formatDate(props.data.upperTitle)}
							</>
						}
						fontWeight={300}
						size={Size.XXS}
						style={{
							textTransform: "uppercase",
						}}
						variant={Variant.Paragraph}
						noPadding
					/>
					{/* <ButtonComponent buttonType={"readMore"} asLink>
						<Translate>Read More</Translate>
					</ButtonComponent> */}
				</div>
			</div>
		</Link>
	)
}

export default BlogCardHorizontal
